module.exports = __webpack_public_path__ + "static/img/icon_wechatmini_products_title.11a26ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_wechatmini_products_title.png
// module id = uTX6
// module chunks = 1